<template>
  <!-- Widgets builder -->
  <main class="wrapper-content">
    <h1>Generador de Widgets</h1>
    <LmComponentLoading v-if="isLoading" fixed />
    <b-row>
      <b-col cols="6">
        <section id="widget-builder-section">
          <h3 class="mb-4">Configuración</h3>
          <header class="d-flex justify-content-between align-items-center bg-primary text-white px-3 py-1 shadow rounded-lg">
            <h4>{{ widget.name || 'Nombre del widget' }}</h4>
          </header>
          <div class="p-4 border border-top-0 rounded-lg">
            <b-row>
              <!-- <LmSelect
                class="col-12"
                label="Tipo de widget"
                v-model="widgetTypesSelected"
                :options="widgetTypesOptions"
                @input="onSelectWidgetType"
              />  -->
              <LmTreeSelect
                class="col-12"
                label="Tipo de widget"
                v-model="widgetTypesSelected"
                :options="widgetTypesOptionsTS"
                @select="onSelectWidgetType"
              />
            </b-row>
            <Component
              ref="widgetBuilderComponent"
              :is="widgetType"
              v-model="widget"
              :isOnEditMode="isOnEditMode"
            />
          </div>

        </section>
      </b-col>
      <b-col cols="6">
        <section id="widget-preview-section">
          <LmWidget
            v-if="widgetType || isOnEditMode"
            :widget="widgetPreview"
          />
          <div v-else>
            <LmSvgIcon
              icon="LmSettingsIcon"
              width="18em"
              wrapperClass="my-4 d-flex align-items-center flex-column"
              text="Selecciona una tipo de Widget para comenzar a configurarlo"
            />
          </div>
        </section>
      </b-col>
    </b-row>
    <div class="buttons">
      <LmButton
              :value="$t('go_back')"
              type="button"
              :isProcessing="isProcessing"
              buttonClass="btn-secondary"
              @click="onGoBack()"
            />
            <LmButton
              type="button"
              buttonClass="btn-primary"
              :value="$t('save')"
              @click="onSave"
            />
            <LmButton
              v-if="isOnEditMode"
              type="button"
              action="delete"
              buttonClass="btn-danger"
              :value="$t('delete')"
              @click="onDelete"
            />
    </div>
  </main>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'
import { getWidgetProps } from '@/helpers/LmWidgets'
import lmToasts from '@/mixins/lmToasts.js'

// Components
import LmSelect from '@/components/form/elements/LmSelect'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmWidget from '@/components/LmWidget'

// Builder Components
import LmListBuilder from '@/components/widgets/builders/LmListBuilder'
import LmDataTableBuilder from '@/components/widgets/builders/LmDataTableBuilder'
import LmTitleBuilder from '@/components/widgets/builders/LmTitleBuilder'
import LmEChartPieBuilder from '@/components/widgets/builders/LmEChartPieBuilder'
import LmEChartBarsBuilder from '@/components/widgets/builders/LmEChartBarsBuilder'
import LmCounterBuilder from '@/components/widgets/builders/LmCounterBuilder'

export default {
  mixins: [lmToasts],
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  components: {
    LmSelect,
    LmTreeSelect,
    LmButton,
    LmWidget,
    LmListBuilder,
    LmDataTableBuilder,
    LmTitleBuilder,
    LmEChartPieBuilder,
    LmEChartBarsBuilder,
    LmCounterBuilder
  },
  data () {
    return {
      isLoading: false,
      widget: {},
      widgetType: '',
      widgetTypesSelected: '',
      widgetTypesOptions: {
        disabledOption: 'Seleccione una opción',
        content: []
      },
      widgetTypesOptionsTS: []
    }
  },
  computed: {
    component () {
      return this.widgetType.replace('Builder', '')
    },
    properties () {
      return {
        properties: this.widget
      }
    },
    widgetPreview () {
      return {
        label: null,
        type: 'single',
        render: {
          name: this.widget.name,
          properties: {
            ...this.widget
          },
          component: this.component,
          componentName: this.widgetTypesSelected.name
        }
      }
    }
  },
  methods: {
    onSelectWidgetType (event) {
      this.widget = getWidgetProps(event.id, this.widget)
      this.widgetType = event.id
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async onSave () {
      try {
        this.isLoading = true
        await this.validateForm(this.$refs.widgetBuilderComponent.$v)
        const widget = {
          name: this.widget.name,
          properties: {
            ...this.widget
          },
          component: this.component,
          componentName: this.widgetTypesSelected.name
        }
        if (this.isOnEditMode) {
          const res = await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/${this.$route.params.id}`, widget)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.name || ' el widget'} correctamente.`, 'Se guardó exitosamente')
        } else {
          const res = await commonsApi.axiosPostWrapper('/widgets', widget)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.name || ' el widget'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    onGoBack () {
      this.$router.go(-1)
    },
    async onDelete () {
      try {
        this.isLoading = true
        await commonsApi.axiosDeleteWrapper(`/${this.serviceEndpoint}/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          `${this.$t('was_successfully_deleted')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
        this.onGoBack()
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      // Cargo los tipos de widgets posibles
      const widgetTypes = await commonsApi.axiosGetWrapper(`${this.serviceEndpoint}/types`)

      // Modifico el value de las opciones
      this.widgetTypesOptionsTS = widgetTypes.data

      // Cargo el widget en modo edición
      if (this.isOnEditMode) {
        const widget = await commonsApi.axiosGetWrapper(`/widgets/${this.$route.params.id}`)
        this.widgetType = `${widget.data.component}Builder`
        this.widget = widget.data.properties
        this.widgetTypesSelected = {
          id: `${widget.data.component}Builder`,
          name: widget.data.componentName
        }
        this.widget = getWidgetProps(this.widgetTypesSelected.id, widget.data.properties)
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
